module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGde6ce13823ca81734facefbeb51eebf8.de6ce138.png";